/* GASSISA
=========================================================================================
* Descripción: 
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 17/09/2024 | Lic. José Luis Aragón Cervantes  | Creación
 *      2       | 31/05/2026 | Lic. José Luis Aragón Cervantes  | Exposición de focus y select
 *      3       | 02/07/2026 | Lic. José Luis Aragón Cervantes  | Soporte customArticleLookup, tecla Enter explícita para Android
 *      4       | 23/09/2026 | LIC. José Luis Aragón C.                       | Deshabilita autocomplete del lector
 * --------------------------------------------------------------------------------------- */

import React, { useState, useRef, forwardRef, useImperativeHandle, useEffect } from 'react';
import { apiBuscarArticuloPorCodigoBarras } from '../../settings/ApiConfig';
import { Box } from '@mui/material';

import FileInput from "../utils/FileInput";
import { useInventarios } from '../../context/Inventarios/InventariosContext';
import { useSesion } from '../../context/System/SesionContext'
import { useRequest } from '../../context/System/RequestContext';

const SizeSoftXLectorCodigoBarrasGeneral = forwardRef((props, ref) => {
  const { handleRegistrarArticulo, TipoVentana = "ENTRADA", statusBotonCarga = false, sx, disabled = false, customArticleLookup } = props;

  const inputRef = useRef();

  useImperativeHandle(ref, () => ({
    focus: () => {
      inputRef.current?.focus();
    },
    select: () => {
      inputRef.current?.select();
    },
    focusAndSelect: () => {
      inputRef.current?.focus();
      inputRef.current?.select();
    }
  }));

  const { GetRequest } = useRequest();

  const [barcode, setBarcode] = useState('');
  const { parametrosCajaForm } = useSesion();

  const {
    handleCargarEscaneosFromFile,
    handleBuscarArticuloDescripcion,
    statusKeyActions = false,
  } = useInventarios();

  const [statusCliente, setStatusCliente] = useState(false);
  const [dataArticulo, setDataArticulo] = useState({});

  const handleKeyDown = async (event) => {
    if (statusKeyActions) return;
    
    if (event.key === 'Enter') {
      event.preventDefault();
      if (barcode.trim()) {
        await handleBuscarArticuloFullData(barcode);
        setBarcode('');
        inputRef.current?.focus();
        inputRef.current?.select();
      }
    } else if (event.key === 'F1') {
      event.preventDefault();
      handleBuscarArticuloDescripcion();
      setBarcode('');
    } else if (event.key === 'Delete' || event.key === 'Escape') {
      setBarcode('');
    }
  };

  const handleOnChange = (e) => {
    setBarcode(e.target.value);
  };

  const handleBuscarArticuloFullData = async (e) => {
    let result;

    if (typeof customArticleLookup === 'function') {
      result = await customArticleLookup(e);
    } else {
      const response = await GetRequest({
        url: apiBuscarArticuloPorCodigoBarras.replace("{codigobarras}", e),
        alert: "Buscando artículo por código de barras"
      });

      if (response.hasError) {
        setDataArticulo({});
        return;
      }

      result = response?.result;
    }

    if (!result) {
      setDataArticulo({});
      return;
    }

    setDataArticulo(result);
    await handleRegistrarArticulo(result);
    return result;
  };

  return (
    <Box className="framedetallesventacodigobarrasentradassalidas"
      style={{
        width: '100%',
        height: '100%',
        margin: '0',
        padding: '0',
        overflowX: 'hidden',
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '4px',
        ...sx,
      }}
    >
      <h2 className="framedetallesventalabelcodigobarras" style={{ margin: 0, padding: 0, fontSize: 'inherit' }}>Lector códigos</h2>
      <input
        id="txtCodigoBarras"
        type="text"
        inputMode="text"
        enterKeyHint="enter"
        tabIndex={1}
        autoFocus
        autoComplete="off"
        name="lector-codigo-barras"
        aria-autocomplete="none"
        autoCorrect="off"
        autoCapitalize="off"
        spellCheck={false}
        data-lpignore="true"
        data-1p-ignore="true"
        className="txtCodigoBarras"
        ref={inputRef}
        value={barcode}
        onChange={handleOnChange}
        onKeyDown={handleKeyDown}
        placeholder="Escanear los códigos de barras aquí"
        disabled={statusKeyActions || disabled}
        style={{ width: '100%', maxWidth: '200px' }}
      />
      {statusBotonCarga && (
        <>
          <button onClick={() => document.getElementById('inputArchivo').click()} className="custom-file-upload_general" disabled={statusKeyActions || disabled}>
            Cargar escaneos desde archivo.txt
          </button>
          <input
            type="file"
            id="inputArchivo"
            accept=".txt"
            style={{ display: 'none' }}
            onChange={handleCargarEscaneosFromFile}
            disabled={disabled}
          />
        </>
      )}
    </Box>
  );
});

export default SizeSoftXLectorCodigoBarrasGeneral;
